import { useLocation, matchPath } from "react-router-dom";
import projetosData from "../../data/projetosGerais.json";

function TrilhaNavegacao({ aoIrHome, aoIrCategoria }) {

  const location = useLocation();

  function obterTagTecnologia(tags) {

  if (!tags) return null;

  const tecnologiasValidas = ["RA", "RV", "Vídeo 360", "Vídeo 360i"];

  return tags.find(function (tag) {
    return tecnologiasValidas.includes(tag);
  });
}

  const mapaTags = {
    RA: "Realidade Aumentada",
    RV: "Realidade Virtual",
  };

  const mapaRotas = {
    RA: "/ra",
    RV: "/rv",
    "Vídeo 360": "/video360",
    "Vídeo 360i": "/video360i",
  };

  const mapaCategorias = {
    "/ra": "Realidade Aumentada",
    "/rv": "Realidade Virtual",
    "/video360": "Vídeo 360",
    "/video360i": "Vídeo 360i",
  };

  /* ========================= DETALHES ========================= */

  const matchDetalhe = matchPath("/projeto/:id", location.pathname);

  if (matchDetalhe) {

    const projetoId = Number(matchDetalhe.params.id);

    const projeto = projetosData.find(function (p) {
      return p.id === projetoId;
    });

    if (!projeto) {
      return null;
    }

    const mainTag = obterTagTecnologia(projeto.tags);
    // Nome exibido
    const nomeTag = mapaTags[mainTag] ? mapaTags[mainTag] : mainTag;

    return (
      <nav className="TrilhaNavegacao">

        <span
          className="TrilhaNavegacao-link"
          onClick={aoIrHome}
        >
          Home
        </span>

        <span className="TrilhaNavegacao-separador">|</span>

        <span
          className="TrilhaNavegacao-link"
          onClick={function () {
            const rota = mapaRotas[mainTag];
            if (rota) {
              aoIrCategoria(rota);
            }
          }}
        >
          {nomeTag}
        </span>

        <span className="TrilhaNavegacao-separador">|</span>

        <span className="TrilhaNavegacao-atual">
          {projeto.titulo}
        </span>

      </nav>
    );
  }

  /* ========================= CATEGORIA ========================= */

  const categoriaAtual = Object.keys(mapaCategorias).find(function (rota) {
    return location.pathname.startsWith(rota);
  });

  if (categoriaAtual) {
    return (
      <nav className="TrilhaNavegacao">

        <span
          className="TrilhaNavegacao-link"
          onClick={aoIrHome}
        >
          Home
        </span>

        <span className="TrilhaNavegacao-separador">|</span>

        <span className="TrilhaNavegacao-atual">
          {mapaCategorias[categoriaAtual]}
        </span>

      </nav>
    );
  }

  /* ========================= BUSCA ========================= */

  const possuiQueryBusca = location.search.includes("?q=");

  if (possuiQueryBusca) {
    return (
      <nav className="TrilhaNavegacao">

        <span
          className="TrilhaNavegacao-link"
          onClick={aoIrHome}
        >
          Home
        </span>

        <span className="TrilhaNavegacao-separador">|</span>

        <span className="TrilhaNavegacao-atual">
          Resultados
        </span>

      </nav>
    );
  }

  return null;
}

export default TrilhaNavegacao;